import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
});

export default {
    'api1': {
        onLoad: true,
        action: (lang, match, query) => {
            return fetch(API_ENDPOINT + '/data/hornbach-stock', {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify({
                    page: query.page,
                    entries: query.entries,
                    filter: query.filter,
                    sortType: query.sortType,
                    sortField: query.sortField,
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300)
                    return {
                        items: result.items || [],
                        total: result.total || 0,
                    }
                return { items: [], total: 0 };
            })
        }
    },

    // create
    'api2': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/hornbach-stock/new', {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify(data.data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    // delete
    'api3': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/hornbach-stock/' + data.data, {
                method: 'DELETE',
                headers: authHeaders(),
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    // update
    'api4': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/hornbach-stock/' + data.data._id, {
                method: 'PUT',
                headers: authHeaders(),
                body: JSON.stringify(data.data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    // gtin uniqueness validation (available for the add/edit form)
    'validate': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/hornbach-stock/validate/' + data.value + '/' + data.id, {
                method: 'GET',
                headers: authHeaders(),
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },
};
